import {createContext, useState, createElement} from 'react';

const MiniFormContext = createContext({formEditable: true});

const MiniFormProvider = ({children}) => {
    const [formEditable, setFormEditable] = useState(false);
    return (
        <MiniFormContext.Provider value={{formEditable, setFormEditable}}>
            {children}
        </MiniFormContext.Provider>
    );
};

const withMiniFormProvider = Component => props => {
    return (
        <MiniFormProvider>{createElement(Component, props)}</MiniFormProvider>
    );
};

export default MiniFormProvider;
export {MiniFormContext, MiniFormProvider, withMiniFormProvider};
